var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2433_48593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2433_48593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5837 4.25065V12.7507C15.5837 13.1402 15.4449 13.4737 15.1675 13.7512C14.8901 14.0286 14.5566 14.1673 14.167 14.1673H2.83366C2.44408 14.1673 2.11057 14.0286 1.83314 13.7512C1.55571 13.4737 1.41699 13.1402 1.41699 12.7507V4.25065C1.41699 3.86107 1.55571 3.52756 1.83314 3.25013C2.11057 2.9727 2.44408 2.83398 2.83366 2.83398H14.167C14.5566 2.83398 14.8901 2.9727 15.1675 3.25013C15.4449 3.52756 15.5837 3.86107 15.5837 4.25065ZM2.83366 5.66732H14.167V4.25065H2.83366V5.66732ZM2.83366 8.50065V12.7507H14.167V8.50065H2.83366Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.6e27a33b3589efed1a284fac3f26415c.svg";
export { ForwardRef as ReactComponent };